import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../services/apiService';

export default function ActivatePage() {
  const navigate = useNavigate();

  const [form, setForm]   = useState({ email: '', businessId: '', tempCode: '', newPassword: '', confirm: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // autofill from URL params
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setForm(f => ({
      ...f,
      email:      params.get('email')      || '',
      businessId: params.get('businessId') || '',
      tempCode:   params.get('code')       || '',
    }));
  }, []);

  const change = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.newPassword !== form.confirm) return setError('Passwords do not match.');
    setLoading(true);
    try {
      await apiService.activate(form.email, form.businessId, form.tempCode, form.newPassword);
      navigate('/login', { state: { message: 'Account activated! Please sign in.' } });
    } catch (err) {
      setError(err.message || 'Activation failed.');
    } finally {
      setLoading(false);
    }
  };

  // determine which fields are autofilled
  const params = new URLSearchParams(window.location.search);
  const hasParams = params.get('email') && params.get('businessId') && params.get('code');

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.logo}>Aetheris</h1>
        <p style={styles.sub}>Activate your account</p>
        <p style={styles.hint}>
          {hasParams ? 'Just choose a password to complete your setup.' : 'Enter the activation code from your invite email.'}
        </p>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit} style={styles.form}>
          {/* only show these if not autofilled */}
          {!hasParams && (
            <>
              <input style={styles.input} name="email"      type="email" placeholder="Your email"    value={form.email}      onChange={change} required />
              <input style={styles.input} name="businessId" type="text"  placeholder="Business ID"   value={form.businessId} onChange={change} required />
              <input style={styles.input} name="tempCode"   type="text"  placeholder="Activation code (e.g. KPR-9XM4JH)" value={form.tempCode} onChange={change} required />
            </>
          )}

          {hasParams && (
            <div style={styles.infoBox}>
              <div style={styles.infoRow}><span style={styles.infoLabel}>Email</span><span>{form.email}</span></div>
              <div style={styles.infoRow}><span style={styles.infoLabel}>Company</span><span>{form.businessId}</span></div>
              <div style={styles.infoRow}><span style={styles.infoLabel}>Code</span><span style={{letterSpacing:2}}>{form.tempCode}</span></div>
            </div>
          )}

          <input style={styles.input} name="newPassword" type="password" placeholder="Choose a password (min 8 chars)" value={form.newPassword} onChange={change} required minLength={8} />
          <input style={styles.input} name="confirm"     type="password" placeholder="Confirm password"                value={form.confirm}     onChange={change} required />

          <button style={styles.btn} type="submit" disabled={loading}>
            {loading ? 'Activating…' : 'Activate Account'}
          </button>
        </form>

        <p style={styles.link}>
          Already activated?{' '}
          <span style={styles.a} onClick={() => navigate('/login')}>Sign in</span>
        </p>
      </div>
    </div>
  );
}

const styles = {
  page:     { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)', fontFamily: 'system-ui, -apple-system, sans-serif' },
  card:     { background: 'rgba(15, 23, 42, 0.95)', border: '1px solid rgba(59, 130, 246, 0.2)', borderRadius: '16px', padding: '48px', width: '100%', maxWidth: '420px', boxShadow: '0 25px 50px rgba(0,0,0,0.5)' },
  logo:     { fontSize: '32px', fontWeight: 'bold', color: '#6C63FF', textAlign: 'center', marginBottom: '8px', textShadow: '0 0 20px rgba(108,99,255,0.5)' },
  sub:      { color: '#e2e8f0', textAlign: 'center', marginBottom: '4px', fontSize: '18px', fontWeight: '600' },
  hint:     { color: '#94a3b8', textAlign: 'center', marginBottom: '24px', fontSize: '13px' },
  form:     { display: 'flex', flexDirection: 'column', gap: '16px' },
  input:    { padding: '12px 16px', background: 'rgba(30, 41, 59, 0.8)', border: '1px solid rgba(59, 130, 246, 0.2)', borderRadius: '8px', color: '#e2e8f0', fontSize: '14px', outline: 'none' },
  btn:      { padding: '14px', background: 'linear-gradient(135deg, #6C63FF, #3b82f6)', border: 'none', borderRadius: '8px', color: 'white', fontSize: '16px', fontWeight: '600', cursor: 'pointer', marginTop: '8px' },
  error:    { background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '8px', padding: '12px', color: '#f87171', fontSize: '14px', marginBottom: '8px' },
  link:     { color: '#64748b', fontSize: '13px', textAlign: 'center', marginTop: '24px' },
  a:        { color: '#6C63FF', cursor: 'pointer', textDecoration: 'underline' },
  infoBox:  { background: 'rgba(108,99,255,0.08)', border: '1px solid rgba(108,99,255,0.2)', borderRadius: '8px', padding: '12px 16px', display: 'flex', flexDirection: 'column', gap: '6px' },
  infoRow:  { display: 'flex', justifyContent: 'space-between', fontSize: '13px', color: '#e2e8f0' },
  infoLabel:{ color: '#64748b', marginRight: '8px' },
};
